import { render, staticRenderFns } from "./addItemForm.vue?vue&type=template&id=390d6586&scoped=true&"
import script from "./addItemForm.vue?vue&type=script&lang=js&"
export * from "./addItemForm.vue?vue&type=script&lang=js&"
import style0 from "./addItemForm.vue?vue&type=style&index=0&id=390d6586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390d6586",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/afridev/plan_action/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390d6586')) {
      api.createRecord('390d6586', component.options)
    } else {
      api.reload('390d6586', component.options)
    }
    module.hot.accept("./addItemForm.vue?vue&type=template&id=390d6586&scoped=true&", function () {
      api.rerender('390d6586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/addItemForm.vue"
export default component.exports